const questions = [
  {
    title: 'Wie viele Personen leben in Ihrem Haushalt?',
    name: 'person',
    condition: null,
    id: 1,
    type: 'choiceCard',
    options: [
      {
        text: '1 Person',
        param: 1,
      },
      {
        text: '2 Personen',
        param: 2,
      },
      {
        text: '3 Personen',
        param: 3,
      },
      {
        text: 'Mehr als 3 Personen',
        param: 4,
      },
    ],
  },
  {
    title: 'Wie viele Wochen, über das Jahr verteilt, ist niemand zu Hause?',
    name: 'weeks',
    condition: null,
    id: 2,
    type: 'choiceCard',
    options: [
      {
        text: 'Weniger als 2 Wochen',
        param: 2,
      },
      {
        text: '4 Wochen',
        param: 4,
      },
      {
        text: '6 Wochen',
        param: 6,
      },
      {
        text: 'Mehr als 6 Wochen',
        param: 8,
      },
    ],
  },
  {
    title: 'Womit wird in Ihrem Haushalt Warmwasser aufgeheizt?',
    name: 'heating',
    condition: 2,
    id: 3,
    type: 'choiceCard',
    options: [
      {
        text: 'Strom',
        param: 1,
      },
      {
        text: 'Gas',
        param: 2,
      },
      {
        text: 'Fernwärme',
        param: 3,
      },
    ],
  },
  {
    title: 'Hat Ihre Gastherme eine Zündflame?',
    name: 'flame',
    condition: null,
    id: 4,
    type: 'choiceCard',
    options: [
      {
        text: 'Ja',
        param: 1,
      },
      {
        text: 'Nein',
        param: 2,
      },
    ],
  },
  {
    title: 'Welche Armaturen haben Sie in Bad und Küche für Warmwasser?',
    subTitle:
      'Bei Standard-Armaturen haben Sie zwei Griffe. Einen für kaltes Wasser und einen für warmes Wasser. Bei Einhand- bzw. Thermostat Armaturen haben Sie nur einen Griff. Bitte wählen Sie "Standard", wenn Sie beides zu Hause haben.',
    name: 'faucet',
    condition: null,

    id: 5,
    type: 'choiceCard',
    options: [
      {
        text: 'Standard-Armaturen',
        param: 1,
      },
      {
        text: 'Einhand- bzw. Thermostat-Armatur',
        param: 2,
      },
    ],
  },
  {
    title: 'Wie oft wird in Ihrem Haushalt pro Woche geduscht oder gebadet?',
    subTitle:
      'Für die Berechnung des Energiebedarfs ist der Wasserverbrauch relevant. Dieser lässt sich am einfachsten durch die Durchflussmenge pro Minute berechnen. Ob das Wasser zum Duschen oder fürs Baden verwendet wird, ist dabei egal. Ein 20-minütiger Duschgang hat denselben Energieverbrauch wie ein Bad, in das für 20 Minuten Wasser eingelassen wurde.',
    name: 'shower',
    condition: null,
    id: 6,
    type: 'input',
  },
  {
    title:
      'Wenn Sie duschen oder baden, wie viele Minuten lassen Sie das Wasser dafür laufen?',
    name: 'showerTime',
    condition: null,
    id: 7,
    type: 'slider',
  },
  {
    title: 'Verwenden Sie einen Sparduschkopf?',
    subTitle:
      'Sparduschköpfe reduzieren die Wassermenge, die aus dem Wasserhahn kommt. Das ist durch die Beimischung von Luft möglich. So kann effektiv Verbrauch und Energie eingespart werden.',
    name: 'showerHead',
    condition: null,
    id: 8,
    type: 'choiceCard',
    options: [
      {
        text: 'Ja',
        param: 1,
      },
      {
        text: 'Nein',
        param: 2,
      },
    ],
  },
  {
    title: 'Waschen Sie Ihr Geschirr mit der Hand ab?',
    subTitle:
      'Geschirrspüler sind für die Berechnung von Warmwassser irrelevant. Die sind nur an die Kaltwasser-Leitung angeschlossen und erhitzen das Wasser selbst.',
    name: 'handDishwasher',
    condition: 1,
    id: 9,
    type: 'choiceCard',
    options: [
      {
        text: 'Ja',
        param: 1,
      },
      {
        text: 'Nein',
        param: 2,
      },
    ],
  },
  {
    title: 'Wie waschen Sie Ihr Geschirr per Hand?',
    name: 'handDishwasherType',
    condition: null,
    id: 10,
    type: 'choiceCard',
    options: [
      {
        text: 'Ich befülle das Spülbecken mit Wasser und wasche darin das Geschirr.',
        param: 1,
      },
      {
        text: 'Ich spüle es einfach unter fließendem Wasser im Spülbecken.',
        param: 2,
      },
    ],
  },
];

const base = {
  // 1: Strom, 2: Gas, 3: Fernwärme

  1: {
    1: 1100,
    2: 1850,
    3: 2600,
    4: 3400,
  },
  2: {
    1: 1500,
    2: 2600,
    3: 3700,
    4: 4800,
  },
  3: {
    1: 22,
    2: 44,
    3: 65,
    4: 87,
  },
};
const getPercentage = (param, total) => Math.round((param / total) * 100 - 100);

const literToKwh = (liter, stoff) => {
  const constant = {
    1: 0.08,
    2: 0.1,
    3: 0,
  };
  return liter * constant[stoff];
};

const getResultsWasser = answers => {
  /** ***** Get all values according to answers ****** */

  const personen = answers.filter(answer => answer.label === 'person')[0].param;
  const weeks = answers.filter(answer => answer.label === 'weeks')[0].param;
  const stoff = answers.filter(answer => answer.label === 'heating')[0].param;
  const flame = // Flame has value only if gas is selected
    stoff === 2
      ? answers.filter(answer => answer.label === 'flame')[0].param
      : 0;
  const amaturen = answers.filter(answer => answer.label === 'faucet')[0].param;
  const showerIntitalValue = Number(
    answers.filter(answer => answer.label === 'shower')[0].param,
  );
  const duration = Number(
    answers.filter(answer => answer.label === 'showerTime')[0].param,
  );
  const sparDusche = answers.filter(answer => answer.label === 'showerHead')[0]
    .param;
  const dishwasher = answers.filter(
    answer => answer.label === 'handDishwasher',
  )[0].param;

  const handwashWay =
    dishwasher === 1
      ? answers.filter(answer => answer.label === 'handDishwasherType')[0].param
      : null;

  const baseValue = base[stoff][personen]; // 2600
  const shower = showerIntitalValue > 400 ? 400 : showerIntitalValue; //  max 400
  const flameValue = flame === 1 ? 800 : 0; // the value is in kwh and only for Gas
  const amaturenValue = amaturen === 1 ? 1.05 : 1; // 5% mehr verbrauch bei standard amaturen
  const weeksPerYear = 52;
  const weeksAtHome = weeksPerYear - weeks;
  const sparDuscheValue = sparDusche === 1 ? 7 : 10;
  const showerLiterPerWeek = shower * duration * sparDuscheValue;
  const showerLiterPerYear = showerLiterPerWeek * weeksAtHome; // per liter

  const handwashWayValue = handwashWay === 1 ? 7 : 10; //  liter per Gedeck
  const handWashValue =
    dishwasher === 2 ? 0 : handwashWayValue * 7 * weeksAtHome * personen; //  liter per Gedeck , 7 Gedeck pro woche, 50 wochen

  const totalLiterPerYear =
    (showerLiterPerYear + handWashValue) * amaturenValue;

  let totalKwhPerYear = literToKwh(totalLiterPerYear, stoff);
  if (stoff === 2 && flame === 1) {
    // if gas and Zündflame
    totalKwhPerYear += flameValue;
  }
  const isFernwärme = stoff === 3;
  const verbrauch = isFernwärme ? totalLiterPerYear / 1000 : totalKwhPerYear; // if stoff is Fernwärme then kubikmeter else kwh
  const percentage = getPercentage(verbrauch, baseValue);

  const result = {
    verbrauch: Math.round(verbrauch / 10) * 10,
    percentage,
    isFernwärme,
  };

  return result;
};

export { questions, getResultsWasser };
